import { useState } from 'react';
import PhotoMotion from '@/components/feature/PhotoMotion';

type Props = { name: string; images: string[] };

const ALTS = ['whole', 'cut to show the crumb', 'detail of the crust'];
/** Resting proportions (REF-07 5 : 3 : 2.4). The hovered panel takes the largest share. */
const REST = [5, 3, 2.4];
/** Settle per panel: dominant leads, supporting panels follow. Above the fold, so it starts on load. */
const SETTLE = [
  { delay: 0, fromScale: 1.05, fromY: 20, duration: 1.2 },
  { delay: 0.12, fromScale: 1.045, fromY: 16, duration: 1.1 },
  { delay: 0.22, fromScale: 1.045, fromY: 16, duration: 1.1 },
];
const BIG = 5;
const SMALL = 2.4;

/** Desktop: flex row where the hovered / focused panel expands to the largest. Mobile: one full panel, then a pair. */
export default function ProductGallery({ name, images }: Props) {
  const [active, setActive] = useState<number | null>(null);

  const grow = (i: number) => {
    if (active === null) return REST[i];
    return active === i ? BIG : SMALL;
  };

  return (
    <section
      aria-label={`${name} photographs`}
      className="grid grid-cols-2 md:flex gap-1 bg-[#F5F1EB]"
      onMouseLeave={() => setActive(null)}
    >
      {images.slice(0, 3).map((src, i) => (
        <div
          key={src}
          tabIndex={0}
          onMouseEnter={() => setActive(i)}
          onFocus={() => setActive(i)}
          onBlur={() => setActive(null)}
          style={{ flexGrow: grow(i) }}
          className={`${i === 0 ? 'col-span-2 aspect-[5/4]' : 'aspect-[3/4]'} md:aspect-auto md:basis-0 md:min-w-0 md:h-[min(74vh,760px)] overflow-hidden bg-[#e4e0da] cursor-pointer outline-none focus-visible:ring-1 focus-visible:ring-[#171515] transition-[flex-grow] duration-700 ease-[cubic-bezier(0.2,0.7,0.2,1)] motion-reduce:transition-none`}
        >
          <PhotoMotion {...SETTLE[i]}>
            <img src={src} alt={`${name}, ${ALTS[i]}`} title={`${name} — FOLD. bakery`} className="w-full h-full object-cover object-center" />
          </PhotoMotion>
        </div>
      ))}
    </section>
  );
}